import PropTypes from 'prop-types';
import styled from 'styled-components';
import { InputMixin } from '../../mixins/components/InputMixin';
import { INPUT_SIZES } from '../../constants/INPUT';
import FormControl from '../../js/FormControl';
/**
 * See also [`AdornedInput`](#/Form%20components?id=adornedinput) for additional options
 */

var Input = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "Input",
  componentId: "c11n-8-64-0__sc-4ry0fw-0"
})(["", ""], InputMixin);
Input.displayName = 'Input';
Input.propTypes = {
  /**
   * Used for
   * [autofill](https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill).
   * See the [autofill example](#/Form%20components).
   */
  autoComplete: PropTypes.string,

  /**
   * The size of the input.
   */
  size: PropTypes.oneOf(Object.keys(INPUT_SIZES)),

  /**
   * Signals that there is an error with the value and sets the
   * [aria-invalid](https://www.w3.org/TR/wai-aria/#aria-invalid) property.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  error: PropTypes.bool,

  /**
   * The HTML input type.
   * @ignore
   */
  type: PropTypes.string,

  /**
   * The input should fill the entire width of the container.
   */
  fluid: PropTypes.bool,

  /**
   * Mark the input as required with the native [`required`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/required)
   * attribute.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  required: PropTypes.bool,

  /**
   * Mark the input as disabled with the native [`disabled`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/disabled)
   * attribute.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  disabled: PropTypes.bool,

  /**
   * Mark the input as read-only with the native [`readonly`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/readonly)
   * attribute.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   *
   * @since 8.27.0
   */
  readOnly: PropTypes.bool
};
Input.defaultProps = {
  size: INPUT_SIZES.md,
  type: 'text',
  fluid: true
};
/** @component */

export default Input;
export var StyledInput = Input;